import { Redirect, RouteComponentProps, withRouter } from "react-router";

import React from "react";
import { IErrorBoundaryState } from "../Types/IErrorBoundaryState";
import { appPaths } from "../Constants/appPaths";

class ErrorBoundary extends React.Component<RouteComponentProps, IErrorBoundaryState> {
  constructor(props: RouteComponentProps) {
    super(props);

    this.props.history.listen(() => {
      if (this.state.caughtError) {
        this.setState({ caughtError: false });
      }
    });
    this.state = { caughtError: false };
  }

  componentDidCatch(error: Error) {
    // TODO: Log to server here

    // console.log(error);
    this.setState({ caughtError: true });
  }

  render() {
    if (this.state.caughtError) {
      return <Redirect to={appPaths.generalError} />;
    }
    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
